import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'utils/constants';
import {
  ArrowRight,
  Calculator,
  Package,
  DollarSign,
  Share2,
} from 'lucide-react';
import Button from 'components/Button';
import styles from './index.module.scss';

function Home() {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate(ROUTES.TOOLS.COSTING_CALCULATOR);
  };

  return (
    <div className={styles.container}>
      <div className={styles.hero}>
        <div className={styles.heroIcon}>
          <Calculator size={64} />
        </div>
        <h1 className={styles.heroTitle}>Costing Calculator</h1>
        <p className={styles.heroSubtitle}>
          A free tool provided and created by Abrasoft for everyone. Calculate
          the cost price of manufactured food products with ease. No account
          required - just start calculating.
        </p>
        <div className={styles.heroButtons}>
          <Button size="lg" onClick={handleGetStarted}>
            Start Calculating
            <ArrowRight size={20} style={{ marginLeft: '0.5rem' }} />
          </Button>
        </div>
      </div>

      <div className={styles.features}>
        <div className={styles.featureCard}>
          <div className={styles.featureIcon}>
            <Package size={32} />
          </div>
          <h3 className={styles.featureTitle}>Ingredient Management</h3>
          <p className={styles.featureDescription}>
            Add multiple ingredients with quantities, units, and costs. Supports
            various units including kg, g, lb, L, mL, and pieces.
          </p>
        </div>

        <div className={styles.featureCard}>
          <div className={styles.featureIcon}>
            <DollarSign size={32} />
          </div>
          <h3 className={styles.featureTitle}>Additional Costs</h3>
          <p className={styles.featureDescription}>
            Include packaging, labor, overhead, and any other production costs.
            Calculate total batch cost and cost per unit automatically.
          </p>
        </div>

        <div className={styles.featureCard}>
          <div className={styles.featureIcon}>
            <Share2 size={32} />
          </div>
          <h3 className={styles.featureTitle}>Share & Save</h3>
          <p className={styles.featureDescription}>
            Share your calculations via URL or save them locally. Your data is
            automatically saved in your browser for easy access.
          </p>
        </div>
      </div>

      <div className={styles.cta}>
        <h2 className={styles.ctaTitle}>
          Ready to calculate your product costs?
        </h2>
        <p className={styles.ctaDescription}>
          Start using the Costing Calculator today - completely free, no
          registration required. Perfect for food businesses, bakers, and anyone
          who needs to calculate manufacturing costs.
        </p>
        <div className={styles.ctaButtons}>
          <Button size="lg" onClick={handleGetStarted}>
            Get Started Now
            <ArrowRight size={20} style={{ marginLeft: '0.5rem' }} />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Home;
